// @flow

import qs from 'qs'
import { push } from 'connected-react-router'

import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeaders
} from '../utils/api'
import type { APIError } from '../types'
import type { Action } from '../types/actions/usercourses'
import { setUnreadNotificationsCount } from './mycourses'
import { getErrorAction } from '../utils/actions'
import { addActiveField } from '../utils/addActiveField'
import { useSelector } from 'react-redux'

export const FETCH_USER_COURSES_REQUEST = 'FETCH_USER_COURSES_REQUEST'
export const FETCH_USER_COURSES_SUCCESS = 'FETCH_USER_COURSES_SUCCESS'
export const FETCH_USER_COURSES_FAILURE = 'FETCH_USER_COURSES_FAILURE'
export const FETCH_PAST_USER_COURSES_REQUEST = 'FETCH_PAST_USER_COURSES_REQUEST'
export const FETCH_PAST_USER_COURSES_SUCCESS = 'FETCH_PAST_USER_COURSES_SUCCESS'
export const FETCH_PAST_USER_COURSES_FAILURE = 'FETCH_PAST_USER_COURSES_FAILURE'
export const CLEAR_USER_THINGS = 'CLEAR_USER_THINGS'
export const UPDATE_COURSE_SECTION_END_DATE = 'UPDATE_COURSE_SECTION_END_DATE'

export function clearUserThings(): Action {
  return {
    type: CLEAR_USER_THINGS
  }
}

export function updateCourseSectionEndDate(
  courseSectionId: Number,
  endDate: Number
): Action {
  return {
    type: UPDATE_COURSE_SECTION_END_DATE,
    courseSectionId: courseSectionId,
    endDate: endDate
  }
}
export function fetchUserCoursesRequest(): Action {
  return {
    type: FETCH_USER_COURSES_REQUEST
  }
}

export function fetchUserCoursesSuccess(response: Array<Object>): Action {
  return {
    type: FETCH_USER_COURSES_SUCCESS,
    user_courses: response
  }
}

export function fetchUserCoursesFailure(error: APIError): Action {
  return getErrorAction(FETCH_USER_COURSES_FAILURE, error)
}

export function fetchPastUserCoursesRequest(): Action {
  return {
    type: FETCH_PAST_USER_COURSES_REQUEST
  }
}

export function fetchPastUserCoursesSuccess(response: Array<Object>): Action {
  return {
    type: FETCH_PAST_USER_COURSES_SUCCESS,
    past_user_courses: response
  }
}

export function fetchPastUserCoursesFailure(error: APIError): Action {
  return getErrorAction(FETCH_PAST_USER_COURSES_FAILURE, error)
}

export function fetchUserCourses(
  userId: number,
  displayAll: boolean = false,
  displayPast: boolean = false,
  isMentor: boolean
): Function {
  return async (dispatch, getState) => {
    const state = getState()

    const mentorsParams = !displayAll
      ? `?${qs.stringify(
          displayPast
            ? { q: { from_past_sections: true } }
            : { q: { from_current_mentor_sections: true } }
        )}`
      : ''

    const studentParams = !displayAll
      ? `?${qs.stringify(
          displayPast
            ? { q: { from_past_sections: true } }
            : { q: { from_active_sections: true } }
        )}`
      : ''

    const url = isMentor
      ? `${getApiBaseUrlWithOrg(
          state.organization.orgId
        )}/mentor/course_enrollments${mentorsParams}`
      : `${getApiBaseUrlWithOrg(
        state.organization.orgId
      )}/user/course_enrollments${studentParams}`

    dispatch(
      !displayPast ? fetchUserCoursesRequest() : fetchPastUserCoursesRequest()
    )

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )
      const data = await response.json()

      data.forEach(el =>
        addActiveField(
          el.course_section,
          el.course_section.start_at,
          el.course_section.end_at
        )
      )
      if (!displayPast) {
        const count = data.reduce(
          (a, { unread_notifications_count }) => a + unread_notifications_count,
          0
        )
        dispatch(setUnreadNotificationsCount(count))
      }

      dispatch(
        !displayPast
          ? fetchUserCoursesSuccess(data)
          : fetchPastUserCoursesSuccess(data)
      )
    } catch (error) {
      dispatch(
        !displayPast
          ? fetchUserCoursesFailure(error)
          : fetchPastUserCoursesFailure(error)
      )

      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }

      if (error.response.status === 500) {
        dispatch(push('/error'))
      }
    }
  }
}
